import React, { useState } from 'react';
import { ShowcaseSection, ShowcaseItem } from '../ShowcaseItem';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';
import { Button } from '@/components/ui/button';
import { ButtonGroup, ButtonGroupSeparator } from '@/components/ui/button-group';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from '@/components/ui/accordion';
import { StepperWrapper } from '@/components/custom/stepper/stepper';
import { Finder, FinderTree, FinderFolder, FinderFolderIcon, FinderFolderLabel, FinderSubfolder, FinderTreeItem, FinderContent } from '@/components/custom/finder/finder';
import Breadcrumbs from '@/components/custom/breadcrumbs/breadcrumbs';
import { FiFolder, FiChevronDown, FiChevronRight, FiFile, FiEdit, FiTrash2, FiSettings, FiUser } from 'react-icons/fi';

const STEPS = [{ text: 'Informacoes basicas' }, { text: 'Conteudo' }, { text: 'Configuracoes' }, { text: 'Revisao' }];

const BREADCRUMB_DATA = {
  title: 'Voce esta em',
  nav: [
    { name: 'Cursos', route: '/cursos', isActive: true },
    { name: 'Matematica', route: '/cursos/mat', isActive: true },
    { name: 'Modulo 3 - Algebra', route: '/cursos/mat/3', isActive: false }
  ]
};

const FOLDERS = [
  { id: 'matematica', label: 'Matematica', children: ['Algebra', 'Geometria', 'Trigonometria'] },
  { id: 'portugues', label: 'Portugues', children: ['Gramatica', 'Literatura'] },
  { id: 'fisica', label: 'Fisica', children: ['Mecanica', 'Termodinamica', 'Eletromagnetismo'] }
];

export function NavigationSection() {
  const [currentStep, setCurrentStep] = useState(1);
  const [expanded, setExpanded] = useState(new Set(['matematica']));

  const toggle = id => {
    const next = new Set(expanded);
    if (next.has(id)) next.delete(id);
    else next.add(id);
    setExpanded(next);
  };

  return (
    <ShowcaseSection
      id="navigation"
      title="Navigation"
      description="Tabs, accordion, stepper, finder, breadcrumbs, button-group, dropdown-menu"
    >
      <ShowcaseItem
        label="Tabs"
        description="Tabs com estilo pill"
      >
        <Tabs defaultValue="visao-geral">
          <TabsList>
            <TabsTrigger value="visao-geral">Visao Geral</TabsTrigger>
            <TabsTrigger value="detalhes">Detalhes</TabsTrigger>
            <TabsTrigger value="configuracoes">Configuracoes</TabsTrigger>
          </TabsList>
          <TabsContent value="visao-geral">
            <div className="rounded-lg border border-neutral-200 p-4">
              <p className="m-0 text-sm text-neutral-dark">Conteudo da aba Visao Geral.</p>
            </div>
          </TabsContent>
          <TabsContent value="detalhes">
            <div className="rounded-lg border border-neutral-200 p-4">
              <p className="m-0 text-sm text-neutral-dark">Conteudo da aba Detalhes.</p>
            </div>
          </TabsContent>
          <TabsContent value="configuracoes">
            <div className="rounded-lg border border-neutral-200 p-4">
              <p className="m-0 text-sm text-neutral-dark">Conteudo da aba Configuracoes.</p>
            </div>
          </TabsContent>
        </Tabs>
      </ShowcaseItem>

      <ShowcaseItem
        label="Accordion"
        description="Expansao/colapso para FAQs e listas (Radix)"
      >
        <Accordion
          type="single"
          collapsible
          className="w-full"
        >
          <AccordionItem value="m1">
            <AccordionTrigger>Modulo 1 — Introducao a Algebra</AccordionTrigger>
            <AccordionContent>4 aulas · 2h30min — Conceitos fundamentais de algebra linear, vetores e operacoes basicas.</AccordionContent>
          </AccordionItem>
          <AccordionItem value="m2">
            <AccordionTrigger>Modulo 2 — Equacoes e Inequacoes</AccordionTrigger>
            <AccordionContent>6 aulas · 3h45min — Resolucao de equacoes do 1º e 2º grau, sistemas e inequacoes.</AccordionContent>
          </AccordionItem>
          <AccordionItem value="m3">
            <AccordionTrigger>Modulo 3 — Funcoes</AccordionTrigger>
            <AccordionContent>8 aulas · 4h20min — Funcoes lineares, quadraticas, exponenciais e logaritmicas.</AccordionContent>
          </AccordionItem>
        </Accordion>
      </ShowcaseItem>

      <ShowcaseItem
        label="ButtonGroup"
        description="Agrupamento de botoes (horizontal por default)"
      >
        <div className="space-y-3">
          <ButtonGroup>
            <Button
              variant="outline"
              size="sm"
            >
              Anterior
            </Button>
            <Button
              variant="outline"
              size="sm"
            >
              Proximo
            </Button>
          </ButtonGroup>

          <ButtonGroup>
            <Button
              variant="outline"
              size="sm"
            >
              Salvar
            </Button>
            <ButtonGroupSeparator />
            <Button
              variant="outline"
              size="sm"
            >
              <FiChevronDown size={14} />
            </Button>
          </ButtonGroup>
        </div>
      </ShowcaseItem>

      <ShowcaseItem
        label="DropdownMenu"
        description="Menu suspenso com items, labels e separators"
      >
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="outline">
              Acoes <FiChevronDown size={14} />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <DropdownMenuLabel>Conta</DropdownMenuLabel>
            <DropdownMenuItem>
              <FiUser
                size={14}
                className="mr-2"
              />{' '}
              Perfil
            </DropdownMenuItem>
            <DropdownMenuItem>
              <FiSettings
                size={14}
                className="mr-2"
              />{' '}
              Configuracoes
            </DropdownMenuItem>
            <DropdownMenuSeparator />
            <DropdownMenuLabel>Acoes</DropdownMenuLabel>
            <DropdownMenuItem>
              <FiEdit
                size={14}
                className="mr-2"
              />{' '}
              Editar
            </DropdownMenuItem>
            <DropdownMenuItem className="text-danger">
              <FiTrash2
                size={14}
                className="mr-2"
              />{' '}
              Excluir
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </ShowcaseItem>

      <ShowcaseItem
        label="StepperWrapper"
        description="Indicador vertical de etapas"
      >
        <div className="grid gap-4 md:grid-cols-2">
          <StepperWrapper
            steps={STEPS}
            currentStep={currentStep}
          />
          <div className="flex flex-col gap-2">
            <p className="text-sm text-neutral-dark">
              Passo atual: <strong className="text-primary">{currentStep + 1}</strong> de {STEPS.length}
            </p>
            <div className="flex gap-2">
              <Button
                size="sm"
                variant="outline"
                onClick={() => setCurrentStep(s => Math.max(0, s - 1))}
              >
                Anterior
              </Button>
              <Button
                size="sm"
                onClick={() => setCurrentStep(s => Math.min(STEPS.length - 1, s + 1))}
              >
                Proximo
              </Button>
            </div>
          </div>
        </div>
      </ShowcaseItem>

      <ShowcaseItem
        label="Finder"
        description="Explorador tipo arvore de pastas"
      >
        <Finder>
          <FinderTree>
            {FOLDERS.map(folder => (
              <FinderTreeItem key={folder.id}>
                <FinderFolder
                  isOpen={expanded.has(folder.id)}
                  onClick={() => toggle(folder.id)}
                >
                  <FinderFolderIcon>
                    <FiFolder />
                  </FinderFolderIcon>
                  <FinderFolderLabel>{folder.label}</FinderFolderLabel>
                  {expanded.has(folder.id) ? <FiChevronDown size={16} /> : <FiChevronRight size={16} />}
                </FinderFolder>
                <FinderSubfolder isExpanded={expanded.has(folder.id)}>
                  {folder.children.map(child => (
                    <div
                      key={child}
                      className="flex cursor-pointer items-center gap-2 rounded-md px-3 py-2 text-sm text-neutral-dark hover:bg-bright"
                    >
                      <FiFile size={14} />
                      {child}
                    </div>
                  ))}
                </FinderSubfolder>
              </FinderTreeItem>
            ))}
          </FinderTree>
          <FinderContent>
            <p className="text-sm text-neutral-dark">Selecione uma pasta para ver o conteudo.</p>
          </FinderContent>
        </Finder>
      </ShowcaseItem>

      <ShowcaseItem
        label="Breadcrumbs"
        description="Navegacao hierarquica com ButtonBack"
        previewClassName="overflow-x-auto"
      >
        <div className="relative min-h-[60px] [&_.c-filter]:!static [&_.c-filter]:!w-auto [&_.c-filter]:!pl-0">
          <Breadcrumbs data={BREADCRUMB_DATA} />
        </div>
      </ShowcaseItem>
    </ShowcaseSection>
  );
}
